<template>
  <div class="tabpanel">
    <!-- <pre>
      1: {{ currentPricingData }}<br><br>
      2: {{ currentPricingData[selectedTerm] }}<br><br>
      3. {{ selectedTermData }}
    </pre> -->
    <div class="tabpanel__controls">

      <template v-for="(term, index) in terms">
        <div class="tabpanel__tab" v-if="term.value">
          <input type="radio"
            v-model="activeTab"  
            :id="'tabpanel-tab' + index" 
            :value="index"
          >
          <label :for="'tabpanel-tab' + index">{{ term.value }}-Month</label>
        </div>
      </template>

      <template v-if="!hideProgressBar && pricingRequestStatus != 'DataCompleted' && pricingRequestStatus != 'Loaded'">
        <div class="tabpanel__loader">

          <div class="tabpanel__loader-copy">
            <div class="tabpanel__tiny-spinner">
              <ui-spinner size="tiny" />
            </div>

            {{ batchPretext }} <small :class="{ 'visuallyhidden' : !debugStatus }">{{ batchLabel }}</small>...
            
            <progress-bar></progress-bar>

            <div class="tabpanel__loader-status" :class="{ 'visuallyhidden' : !debugStatus }">
              {{ pricingRequestStatus }}
            </div>
          </div>
          
        </div> <!-- .tabpanel__loader -->
      </template>
    </div>

    <pricing-data-tab-panel
      :term="selectedTerm"
      :pricing-data="currentPricingData[selectedTerm]"
      :pricing-data-totals="currentPricingDataTotals[selectedTerm]"
    ></pricing-data-tab-panel>

  </div>
</template>

<script>
import PricingDataTabPanel from './PricingDataTabPanel.vue'
import ProgressBar from './ProgressBar.vue'
import UiSpinner from '../../../../common/components/UiSpinner'

export default {
  components: {
    'pricing-data-tab-panel': PricingDataTabPanel,
    'progress-bar': ProgressBar,
    'ui-spinner': UiSpinner,
  },
  data() {
    return {
      activeTab: 0,
      hideProgressBar: false
    }
  },
  computed: {
    pricingRequestStatus() {
      return this.$store.getters.pricingRequestStatus
    },
    currentPricingData() {
      return this.$store.getters.currentPricingData
    },
    selectedTermData() {
      return this.currentPricingData[this.selectedTerm]
    },
    currentPricingDataTotals() {
      return this.$store.getters.currentPricingDataTotals
    },
    selectedTerm() {
      return this.terms[this.activeTab].value
    },
    termLength() {
      return this.$store.getters.termLength
    },
    utility() {
      return this.$store.getters.utility
    },
    utilityPlan() {
      return this.$store.getters.utilityPlan.slug
    },
    userId() {
      return this.$store.getters.userId
    },
    debugStatus() {
      return window.location.hostname !== 'energypricebook.com'
    },
    terms() {
      let activeTerms = this.termLength
      if (activeTerms && activeTerms.length > 0) {

        return activeTerms.filter(item => {
          return item.term != ''
        })
        
      } else {
        
        let incompleteTermRow = [{
          term: ''
        }]

        return incompleteTermRow
      }
    },
    currentBatch() {
      return this.$store.getters.currentBatch
    },
    batchPretext() {
      if (this.debugStatus) {
        return 'Calculating History'
      }

      return this.currentBatch === 2 ? 'Calculating History' : 'Calculating Pricing'
    },
    batchLabel() {
      switch (this.pricingRequestStatus) {
        case 'DataStarted':
          return '('+ this.currentBatch +' of 2)'
        
        case 'Batch #1 has finished processing.':
          return '('+ this.currentBatch +' of 2)'
        
        case 'Batch #2 has finished processing.':
        case 'DataCompleted':
        case 'Loaded':
          return ''
        
        default:
          return ''
      }
    }
  },
  methods: {
    setDashboardSortUtility() {
      if (this.utility) {
        this.$store.dispatch('setDashboardSortUtility', {
          code: this.utility.code,
          display_broker_fee: this.utility.display_broker_fee,
          id: this.utility.id,
          name: this.utility.name,
          pricing_req_count: this.utility.pricing_req_count,
          rate_classes_count: this.utility.rate_classes_count,
          state: this.utility.state,
          usage_levels_metric: this.utility.usage_levels_metric,
          visibility: this.utility.visibility,
        })

        localStorage.setItem('epb_utility_sort', JSON.stringify(this.utility))
        localStorage.setItem('epb_uid', this.userId)
      }
    }
  },
  mounted() {
    this.setDashboardSortUtility()
  },
  watch: {
    pricingRequestStatus(status) {
      switch (status) {
        case 'Batch #1 has finished processing.':
        case 'Batch #2 has finished processing.':
          this.$store.dispatch('clearBatchDates')
          break
      }

      if (status === 'DataCompleted') {
        this.hideProgressBar = true
      }
    },
    currentBatch(batch) {
      this.$store.dispatch('clearBatchDates')
    } 
  }
}
</script>
